(ns app.front.view.group.admin.integration.model-codes
  (:require [app.domain.group.integration-config-model :as integration-config-model]
            [app.front.view.group.admin.integration.common :as iconf]
            [app.front.view.group.admin.subs :as gas]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::stored-config
  :<- [::gas/group]
  (fn [group _]
    (some-> group
            :group/model-codes-integration-config
            (select-keys integration-config-model/integration-config-keys))))

(defn view
  "Sub-view for model codes / ICC code connect config on the Integration config page."
  [{:keys [tr group]}]
  (let [group-id (:db/id group)]
    [iconf/config-editor-page
     (util/mmap {:integration-type           :integration-config.type/model-codes
                 :stored-config-subscription [::stored-config]
                 :save-command               :group/save-model-codes-integration}
                tr group-id)]))
